import { Button } from "@itandi/itandi-bb-ui/Button";
import { ModalBody } from "@itandi/itandi-bb-ui/ModalBody";
import { ModalFooter } from "@itandi/itandi-bb-ui/ModalFooter";
import { ModalHeader } from "@itandi/itandi-bb-ui/ModalHeader";
import { Modalv2 } from "@itandi/itandi-bb-ui/Modalv2";
import type React from "react";
import { useState } from "react";

type ConfirmType = "delete" | "save";
type Props = {
	actionText?: string;
	cancelText?: string;
	children: React.ReactNode;
	confirmType: ConfirmType;
	disabled?: boolean;
	handleAccept: () => void | Promise<void>;
	handleCancel: () => void;
	isOpen: boolean;
	title?: string;
};

export const ConfirmModal: React.FC<Props> = ({
	isOpen,
	children,
	handleCancel,
	handleAccept,
	title = "確認",
	confirmType,
	actionText,
	cancelText = "キャンセル",
	disabled = false
}: Props) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const onClickAccept = async () => {
		if (isSubmitting) return;

		setIsSubmitting(true);
		try {
			await handleAccept();
		} finally {
			setIsSubmitting(false);
		}
	};
	return (
		<Modalv2
			isOpen={isOpen}
			onClose={isSubmitting ? (): void => undefined : handleCancel}
			size="s"
		>
			<ModalHeader title={title} />
			<ModalBody>{children}</ModalBody>
			<ModalFooter
				leftArea={
					<Button
						disabled={isSubmitting}
						onClick={handleCancel}
						type="button"
						variant="secondary"
					>
						{cancelText}
					</Button>
				}
				rightArea={
					<Button
						disabled={disabled || isSubmitting}
						loading={isSubmitting}
						onClick={onClickAccept}
						type="button"
						variant={confirmType === "delete" ? "danger" : "primary"}
					>
						{actionText ?? (confirmType === "delete" ? "削除" : "保存")}
					</Button>
				}
			/>
		</Modalv2>
	);
};
